import React from "react";
import UpgradePlanModal from "../../components/UpgradePlanModal/UpgradePlanModal";
import { normalizeSelectedPlan } from "../../shared/billing";

const UpgradePlanPreview = () => {
  const selectedPlan = normalizeSelectedPlan(
    new URLSearchParams(window.location.search).get("selectedPlan")
  ) || "starter";

  return (
    <UpgradePlanModal
      visible={true}
      selectedPlan={selectedPlan}
      onClose={() => {}}
    />
  );
};

export default UpgradePlanPreview;
